import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
    Button,
    Dimmer,
    Form,
    Grid,
    GridColumn,
    GridRow,
    Loader,
    Modal,
    Segment
} from 'semantic-ui-react';
import { Field, Form as FinalForm, FormRenderProps } from 'react-final-form';
import { requestedCreateSpraySubmission } from 'services/spraySubmissions/actions';
import { AppState } from 'services/types';
import { updateQueryString as updateQueryStringAction } from 'services/router/actions';
import EntityDropdownField from 'components/EntityDropdownField';
// @ts-ignore
import SubmittingButton from 'components/SubmittingButton';
// @ts-ignore
import Online from 'components/Online';
import { makeSelectQueryStringBooleanValue } from 'workspaces/react-router-selectors';
import {
    selectSpraySchemaEntityTypeId,
    selectSpraySchemaInnerEntityTypeId
} from 'services/schemas/selectors';
import { RenderDatePicker } from 'forms';
import FieldValues from 'components/FieldValues';
import SprayEventsForSubmissionRequest from 'scenes/Spray/scenes/Submissions/components/SprayEventsForSubmissionRequest';
import {
    removeSelectedSprayEventIdsForSubmission,
    resetSelectedSprayEventIdsforSubmission,
    setSelectedSprayEventIdsForSubmission
} from 'services/selectedSprayEventIdsForSubmission/actions';
import LoadingGate from 'components/LoadingGate';
import ErrorAlert from 'components/ErrorAlert';
import { SPRAY_SUBMISSIONS_NAMESPACE } from 'services/spraySubmissions/constants';
import { selectSelectedSprayEventIdsForSubmission } from 'services/selectedSprayEventIdsForSubmission/selectors';
import VarietyDropdownField from 'components/VarietyDropdownField';
import SemiBold from 'components/SemiBold';
import { CREATE_SPRAY_SUBMISSION_MODAL } from '../../constants';
import SubmissionsSprayEventIdsField from '../SubmissionsSprayEventIdsField';
import SubmissionsSelectedSprayEventIdsField from '../SubmissionsSelectedSprayEventIdsField';
import { SELECTED_SPRAY_EVENT_IDS_TABLE_PAGINATION_NAME } from '../SubmissionsSelectedSprayEventIdsField/constants';
import { SPRAY_EVENT_IDS_TABLE_PAGINATION_NAME } from '../SubmissionsSprayEventIdsField/constants';

import './styles.scss';

interface ConnectedProps {
    isOpen: ReturnType<typeof makeSelectQueryStringBooleanValue>;
    spraySchemaEntityTypeId: ReturnType<typeof selectSpraySchemaEntityTypeId>;
    spraySchemaInnerEntityTypeId: ReturnType<
        typeof selectSpraySchemaInnerEntityTypeId
    >;
    selectedSprayEventIdsForSubmission: ReturnType<
        typeof selectSelectedSprayEventIdsForSubmission
    >;
}

interface DispatchProps {
    createSubmission: typeof requestedCreateSpraySubmission;
    updateQueryString: typeof updateQueryStringAction;
    setSelectedSprayEventIds: typeof setSelectedSprayEventIdsForSubmission;
    removeSelectedSprayEventIds: typeof removeSelectedSprayEventIdsForSubmission;
    resetSelectedSprayEventIds: typeof resetSelectedSprayEventIdsforSubmission;
}

type Props = ConnectedProps & DispatchProps;

export class SubmissionCreateFormComponent extends React.PureComponent<Props> {
    handleSubmit(): void {
        const { createSubmission } = this.props;

        createSubmission();
    }

    handleOnClose(): void {
        const { props } = this;

        props.updateQueryString({
            [CREATE_SPRAY_SUBMISSION_MODAL]: undefined,
            [SELECTED_SPRAY_EVENT_IDS_TABLE_PAGINATION_NAME]: undefined,
            [SPRAY_EVENT_IDS_TABLE_PAGINATION_NAME]: undefined
        });

        props.resetSelectedSprayEventIds();
    }

    render(): React.ReactElement {
        const {
            spraySchemaEntityTypeId,
            spraySchemaInnerEntityTypeId,
            setSelectedSprayEventIds,
            removeSelectedSprayEventIds,
            selectedSprayEventIdsForSubmission
        } = this.props;

        return (
            <React.Fragment>
                <Modal.Header>Create Submission</Modal.Header>
                <Modal.Content>
                    <Online>
                        <SprayEventsForSubmissionRequest />
                    </Online>
                    <FinalForm
                        onSubmit={(): void => this.handleSubmit()}
                        render={(
                            props: FormRenderProps
                        ): React.ReactElement => {
                            const { handleSubmit } = props;

                            return (
                                <Form onSubmit={handleSubmit}>
                                    <FieldValues
                                        fieldNames={[
                                            'startDate',
                                            'endDate',
                                            'entityId',
                                            'varietyId',
                                            'sprayEventIds',
                                            'selectedSprayEventIds'
                                        ]}
                                    >
                                        {({
                                            startDate,
                                            endDate,
                                            entityId,
                                            varietyId,
                                            sprayEventIds,
                                            selectedSprayEventIds
                                        }): React.ReactElement => (
                                            <Grid className="submission-create-form">
                                                <GridRow>
                                                    <GridColumn
                                                        mobile={16}
                                                        tablet={8}
                                                        computer={4}
                                                    >
                                                        <EntityDropdownField
                                                            name="entityId"
                                                            entityTypeId={
                                                                spraySchemaEntityTypeId
                                                            }
                                                        />
                                                    </GridColumn>
                                                    <GridColumn
                                                        mobile={16}
                                                        tablet={8}
                                                        computer={4}
                                                    >
                                                        <VarietyDropdownField name="varietyId" />
                                                    </GridColumn>
                                                </GridRow>
                                                <GridRow>
                                                    <GridColumn
                                                        mobile={8}
                                                        tablet={4}
                                                        computer={2}
                                                    >
                                                        <Field
                                                            name="startDate"
                                                            label="Date range start"
                                                            placeholder="Start date"
                                                            component={
                                                                RenderDatePicker as any
                                                            }
                                                            dateFormat="EEE do MMM"
                                                            selectsStart
                                                            maxDate={endDate}
                                                            subscription={{
                                                                value: true,
                                                                touched: true,
                                                                error: true
                                                            }}
                                                        />
                                                    </GridColumn>
                                                    <GridColumn
                                                        mobile={8}
                                                        tablet={4}
                                                        computer={2}
                                                    >
                                                        <Field
                                                            name="endDate"
                                                            label="Date range end"
                                                            placeholder="End date"
                                                            component={
                                                                RenderDatePicker as any
                                                            }
                                                            dateFormat="EEE do MMM"
                                                            selectsEnd
                                                            minDate={startDate}
                                                            subscription={{
                                                                value: true,
                                                                touched: true,
                                                                error: true
                                                            }}
                                                            clearable={false}
                                                        />
                                                    </GridColumn>
                                                    <GridColumn
                                                        className="action-button-desktop"
                                                        mobile={8}
                                                        tablet={8}
                                                        computer={4}
                                                        textAlign="right"
                                                    >
                                                        <Button
                                                            disabled={
                                                                !sprayEventIds.length
                                                            }
                                                            secondary
                                                            type="button"
                                                            onClick={(): void => {
                                                                setSelectedSprayEventIds(
                                                                    sprayEventIds
                                                                );
                                                                props.form.change(
                                                                    'sprayEventIds',
                                                                    []
                                                                );
                                                            }}
                                                        >
                                                            Add selected
                                                        </Button>
                                                    </GridColumn>
                                                    <GridColumn
                                                        className="action-button-desktop"
                                                        mobile={8}
                                                        tablet={6}
                                                        computer={8}
                                                        textAlign="right"
                                                    >
                                                        <Button
                                                            disabled={
                                                                !selectedSprayEventIds.length
                                                            }
                                                            secondary
                                                            type="button"
                                                            onClick={(): void => {
                                                                removeSelectedSprayEventIds(
                                                                    selectedSprayEventIds
                                                                );
                                                                props.form.change(
                                                                    'selectedSprayEventIds',
                                                                    []
                                                                );
                                                            }}
                                                        >
                                                            Remove selected
                                                        </Button>
                                                    </GridColumn>
                                                </GridRow>
                                                <LoadingGate
                                                    namespace="SPRAY_EVENTS_FOR_SUBMISSION_LOAD"
                                                    LoadingComponent={
                                                        <Segment
                                                            basic
                                                            padded="very"
                                                            style={{
                                                                width: '100%'
                                                            }}
                                                        >
                                                            <Dimmer
                                                                active
                                                                inverted
                                                            >
                                                                <Loader
                                                                    inverted
                                                                />
                                                            </Dimmer>
                                                        </Segment>
                                                    }
                                                >
                                                    <GridRow>
                                                        <GridColumn
                                                            computer="8"
                                                            tablet="16"
                                                            mobile="16"
                                                        >
                                                            <Grid>
                                                                <GridRow>
                                                                    <GridColumn
                                                                        className="action-button-mobile"
                                                                        textAlign="right"
                                                                    >
                                                                        <Button
                                                                            disabled={
                                                                                !sprayEventIds.length
                                                                            }
                                                                            secondary
                                                                            type="button"
                                                                            onClick={(): void => {
                                                                                setSelectedSprayEventIds(
                                                                                    sprayEventIds
                                                                                );
                                                                                props.form.change(
                                                                                    'sprayEventIds',
                                                                                    []
                                                                                );
                                                                            }}
                                                                        >
                                                                            Add
                                                                            selected
                                                                        </Button>
                                                                    </GridColumn>
                                                                </GridRow>
                                                                <GridRow>
                                                                    <GridColumn>
                                                                        <SemiBold>
                                                                            Choose
                                                                            the
                                                                            Spray
                                                                            Events
                                                                            you
                                                                            want
                                                                            to
                                                                            submit
                                                                            and
                                                                            click
                                                                            on
                                                                            Add
                                                                            selected.
                                                                        </SemiBold>
                                                                    </GridColumn>
                                                                </GridRow>
                                                                <GridRow>
                                                                    <GridColumn>
                                                                        <Field
                                                                            component={
                                                                                SubmissionsSprayEventIdsField as any
                                                                            }
                                                                            subscription={{
                                                                                value: true,
                                                                                touched: true,
                                                                                error: true
                                                                            }}
                                                                            name="sprayEventIds"
                                                                            startDate={
                                                                                startDate
                                                                            }
                                                                            endDate={
                                                                                endDate
                                                                            }
                                                                            entityId={
                                                                                entityId
                                                                            }
                                                                            varietyId={
                                                                                varietyId
                                                                            }
                                                                            spraySchemaInnerEntityTypeId={
                                                                                spraySchemaInnerEntityTypeId
                                                                            }
                                                                            spraySchemaEntityTypeId={
                                                                                spraySchemaEntityTypeId
                                                                            }
                                                                        />
                                                                    </GridColumn>
                                                                </GridRow>
                                                            </Grid>
                                                        </GridColumn>
                                                        <GridColumn
                                                            computer="8"
                                                            tablet="16"
                                                            mobile="16"
                                                        >
                                                            <Grid>
                                                                <GridRow>
                                                                    <GridColumn
                                                                        className="action-button-mobile"
                                                                        textAlign="right"
                                                                    >
                                                                        <Button
                                                                            disabled={
                                                                                !selectedSprayEventIds.length
                                                                            }
                                                                            secondary
                                                                            type="button"
                                                                            onClick={(): void => {
                                                                                removeSelectedSprayEventIds(
                                                                                    selectedSprayEventIds
                                                                                );
                                                                                props.form.change(
                                                                                    'selectedSprayEventIds',
                                                                                    []
                                                                                );
                                                                            }}
                                                                        >
                                                                            Remove
                                                                            selected
                                                                        </Button>
                                                                    </GridColumn>
                                                                </GridRow>
                                                                <GridRow>
                                                                    <GridColumn>
                                                                        <SemiBold>
                                                                            These
                                                                            are
                                                                            your
                                                                            selected
                                                                            Spray
                                                                            Events.
                                                                            Click
                                                                            Submit
                                                                            to
                                                                            send
                                                                            them
                                                                            to
                                                                            CropSure.
                                                                        </SemiBold>
                                                                    </GridColumn>
                                                                </GridRow>
                                                                <GridRow>
                                                                    <GridColumn>
                                                                        <Field
                                                                            component={
                                                                                SubmissionsSelectedSprayEventIdsField as any
                                                                            }
                                                                            subscription={{
                                                                                value: true,
                                                                                touched: true,
                                                                                error: true
                                                                            }}
                                                                            name="selectedSprayEventIds"
                                                                            startDate={
                                                                                startDate
                                                                            }
                                                                            endDate={
                                                                                endDate
                                                                            }
                                                                            entityId={
                                                                                entityId
                                                                            }
                                                                            varietyId={
                                                                                varietyId
                                                                            }
                                                                            spraySchemaInnerEntityTypeId={
                                                                                spraySchemaInnerEntityTypeId
                                                                            }
                                                                            spraySchemaEntityTypeId={
                                                                                spraySchemaEntityTypeId
                                                                            }
                                                                        />
                                                                    </GridColumn>
                                                                </GridRow>
                                                            </Grid>
                                                        </GridColumn>
                                                    </GridRow>
                                                </LoadingGate>
                                            </Grid>
                                        )}
                                    </FieldValues>
                                    <ErrorAlert
                                        namespace={SPRAY_SUBMISSIONS_NAMESPACE}
                                    />
                                    <Grid>
                                        <GridRow
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'flex-end'
                                            }}
                                        >
                                            <GridColumn
                                                mobile={16}
                                                tablet={4}
                                                computer={4}
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'flex-end'
                                                }}
                                            >
                                                <Button
                                                    type="button"
                                                    onClick={(): void =>
                                                        this.handleOnClose()
                                                    }
                                                    basic
                                                    primary
                                                    fluid
                                                >
                                                    Cancel
                                                </Button>
                                                <SubmittingButton
                                                    primary
                                                    fluid
                                                    type="submit"
                                                    disabled={
                                                        !selectedSprayEventIdsForSubmission.length
                                                    }
                                                    namespace={
                                                        SPRAY_SUBMISSIONS_NAMESPACE
                                                    }
                                                >
                                                    Submit
                                                </SubmittingButton>
                                            </GridColumn>
                                        </GridRow>
                                    </Grid>
                                </Form>
                            );
                        }}
                    />
                </Modal.Content>
            </React.Fragment>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    isOpen: makeSelectQueryStringBooleanValue(CREATE_SPRAY_SUBMISSION_MODAL),
    spraySchemaEntityTypeId: selectSpraySchemaEntityTypeId,
    spraySchemaInnerEntityTypeId: selectSpraySchemaInnerEntityTypeId,
    selectedSprayEventIdsForSubmission: selectSelectedSprayEventIdsForSubmission
});

export default connect(mapStateToProps, {
    createSubmission: requestedCreateSpraySubmission,
    setSelectedSprayEventIds: setSelectedSprayEventIdsForSubmission,
    removeSelectedSprayEventIds: removeSelectedSprayEventIdsForSubmission,
    resetSelectedSprayEventIds: resetSelectedSprayEventIdsforSubmission,
    updateQueryString: updateQueryStringAction
})(SubmissionCreateFormComponent);
